angular.module('myappointments').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('/myappointments/views/confirmAppointment.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-primary\">\r" +
    "\n" +
    "        <div class=\"panel-heading-appointments panel-flush\">\r" +
    "\n" +
    "            {{::'Your appointment has been requested.' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"text-center ap-margin-bottom-15\">\r" +
    "\n" +
    "            {{:: 'Your request has been sent to the staff for review.  You will receive a message once the status of the request has been updated.' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "            <div class=\"panel-body\">\r" +
    "\n" +
    "                <div class=\"row\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"col-xs-3 col col-xs-flush\"></div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"col-xs-6 ap-confirm-content-area\">\r" +
    "\n" +
    "                        <div class=\"ap-appointment-text\" style=\"color: #515C66; font-size: 16pt; font-family: 'Helvetica Neue Bold', sans-serif;\">\r" +
    "\n" +
    "                            <ap-date-formatter date=\"{{appointment.RequestDateTime}}\" format=\"monthname-dayofmonth\"></ap-date-formatter>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"ap-appointment-text ap-border-bottom\">\r" +
    "\n" +
    "                            @ <ap-date-formatter date=\"{{appointment.RequestDateTime}}\" format=\"time\"></ap-date-formatter>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"ap-appointment-text\" style=\"color: #515C66; font-size: 14pt; font-family: 'Helvetica Neue Bold', sans-serif;\">\r" +
    "\n" +
    "                            {{::appointment.AppointmentTypeName}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"ap-appointment-text\" style=\"color: #515C66; font-size: 11pt; font-family: 'Helvetica Neue Bold', sans-serif;\" ng-if=\"appointment.AppointmentTypeDescription\">\r" +
    "\n" +
    "                            {{::appointment.AppointmentTypeDescription}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"ap-calendar-text\">\r" +
    "\n" +
    "                            {{::appointment.CalendarDescription }}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"ap-appointment-text\">\r" +
    "\n" +
    "                            {{::appointment.Reason}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"ap-practice-text\" ng-if=\"pendingAppointment.VisitLocation.Address1 && pendingAppointment.VisitLocation.City && pendingAppointment.VisitLocation.State && pendingAppointment.VisitLocation.Zip\">\r" +
    "\n" +
    "                            {{::appointmentLocation.Name}}  {{::appointmentLocation.Address1}} | {{::appointmentLocation.City}}, {{::appointmentLocation.State}}  {{::appointmentLocation.Zip}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"ap-appointment-text\" ng-if=\"appointmentLocationDefined\">\r" +
    "\n" +
    "                            <ap-google-maps ng-if=\"appointmentLocationDefined\"\r" +
    "\n" +
    "                                    address=\"appointmentLocation.Address1\"\r" +
    "\n" +
    "                                    city=\"appointmentLocation.City\"\r" +
    "\n" +
    "                                    state=\"appointmentLocation.State\"\r" +
    "\n" +
    "                                    zip=\"appointmentLocation.Zip\">\r" +
    "\n" +
    "                            </ap-google-maps>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div>\r" +
    "\n" +
    "                            <!--<button-->\r" +
    "\n" +
    "                                    <!--id=\"add-to-calendar-btn\"-->\r" +
    "\n" +
    "                                    <!--class=\"btn btn-default2 btn-lg pull-left\"-->\r" +
    "\n" +
    "                                    <!--data-transition-to=\"{appRoute: 'myAppointments'}\">-->\r" +
    "\n" +
    "                                <!--{{::'Add To Calendar' | translate}}-->\r" +
    "\n" +
    "                            <!--</button>-->\r" +
    "\n" +
    "                            <button\r" +
    "\n" +
    "                                    id=\"done-btn\"\r" +
    "\n" +
    "                                    class=\"btn btn-primary btn-lg pull-right\"\r" +
    "\n" +
    "                                    data-transition-to=\"{appRoute: 'myAppointments'}\">\r" +
    "\n" +
    "                                {{::'Done' | translate}}\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"col-xs-3 col col-xs-flush\"></div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                {{::'An error has occurred and the confirmation page could not be loaded.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                {{::'You do not have access to this patient\\'s appointments.'| translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/myappointments/views/myAppointments.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-primary\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"!loading && !httpError\" class=\"panel-body panel-flush\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"text-center ap-margin-bottom-30\" ng-if=\"!pendingAppointment && canRequestAppointments\">\r" +
    "\n" +
    "                <span>{{::'Request a new appointment?' | translate}}</span>&nbsp;&nbsp;\r" +
    "\n" +
    "                <span>\r" +
    "\n" +
    "                    <button id=\"request-new-appointment-btn\" class=\"btn btn-default1\" ng-click=\"requestNewAppointment()\">\r" +
    "\n" +
    "                        {{::'Book Now' | translate}}\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                </span>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"panel-subheading\" ng-if=\"pendingAppointment\">\r" +
    "\n" +
    "                {{::'Pending Appointments' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"row panel-row ap-margin-bottom-30\" id=\"pending-appointments-{{pendingAppointment.MessageId}}\" ng-if=\"pendingAppointment\">\r" +
    "\n" +
    "                <div class=\"col-xs-12 col-xs-flush col-sm-6 col-md-5\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-xs-flush col-sm-6 col-md-5\">\r" +
    "\n" +
    "                        <ap-date-formatter date=\"{{pendingAppointment.StartDateTime}}\" format=\"date-time\"></ap-date-formatter>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <!--<div class=\"col-xs-6 col-xs-flush col-md-4\">-->\r" +
    "\n" +
    "                        <!--{{::'Add to Calendar' | translate}}-->\r" +
    "\n" +
    "                    <!--</div>-->\r" +
    "\n" +
    "                    <div class=\"col-xs-6 col-xs-flush col-md-3\">\r" +
    "\n" +
    "                       <a  ng-click=\"loadMap(pendingAppointment)\" class=\"clickable\" data-toggle=\"modal\" data-target=\"#VisitMap-{{pendingAppointment.MessageId}}\">{{::'Display Map' | translate}}</a>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-9 col-xs-flush col-sm-6 col-md-5 \">\r" +
    "\n" +
    "                    <div>\r" +
    "\n" +
    "                        {{pendingAppointment.AppointmentType.Name}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"clickable\">\r" +
    "\n" +
    "                        <div ng-click = \"toggleFullAppointmentDescriptionPending()\">\r" +
    "\n" +
    "                                <div ng-if=\"!fullAppointmentDescriptionPending\">\r" +
    "\n" +
    "                                    <div class=\"overflow-ellipsis\">\r" +
    "\n" +
    "                                        {{ pendingAppointment.AppointmentType.Description | limitTo: limitTo}}\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                <div ng-if=\"fullAppointmentDescriptionPending\">\r" +
    "\n" +
    "                                    <div class=\"label_wrap\">\r" +
    "\n" +
    "                                    {{ pendingAppointment.AppointmentType.Description }}\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div ng-if=\"pendingAppointment.Provider.Name\">\r" +
    "\n" +
    "                        {{pendingAppointment.Provider.Name}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div ng-if=\"pendingAppointment.VisitLocation.Name\">\r" +
    "\n" +
    "                        {{pendingAppointment.VisitLocation.Name}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div ng-if=\"pendingAppointment.VisitLocation.Address1 && pendingAppointment.VisitLocation.City && pendingAppointment.VisitLocation.State && pendingAppointment.VisitLocation.Zip\">\r" +
    "\n" +
    "                        {{pendingAppointment.VisitLocation.Address1}} | {{pendingAppointment.VisitLocation.City}}, {{pendingAppointment.VisitLocation.State}}  {{pendingAppointment.VisitLocation.Zip}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div ng-if=\"pendingAppointment.VisitLocation.PhoneNumber\">\r" +
    "\n" +
    "                        {{::'p.' | translate }} {{pendingAppointment.VisitLocation.PhoneNumber}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-12 col-xs-flush col-sm-3 col-md-2\">\r" +
    "\n" +
    "                    <button class=\"btn btn-default1 pull-right\" ng-click=\"rescheduleRequestedAppointment()\" ng-if=\"canRequestAppointments\">\r" +
    "\n" +
    "                        {{::' Reschedule ' | translate}}\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div class=\"modal fade\" id=\"VisitMap-{{pendingAppointment.MessageId}}\" tabindex=\"-1\" role=\"dialog\">\r" +
    "\n" +
    "                    <div class=\"modal-dialog\">\r" +
    "\n" +
    "                        <div class=\"modal-content\">\r" +
    "\n" +
    "                            <div class=\"modal-header\">\r" +
    "\n" +
    "                                <button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span>&times;</span></button>\r" +
    "\n" +
    "                                <h4 class=\"modal-title\">{{::'Patient Visit Map' | translate}}</h4>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"modal-body\">\r" +
    "\n" +
    "                                <ap-google-maps ng-if=\"pendingAppointment.mapLoaded\"\r" +
    "\n" +
    "                                        address=\"pendingAppointment.VisitLocation.Address1\"\r" +
    "\n" +
    "                                        city=\"pendingAppointment.VisitLocation.City\"\r" +
    "\n" +
    "                                        state=\"pendingAppointment.VisitLocation.State\"\r" +
    "\n" +
    "                                        zip=\"pendingAppointment.VisitLocation.Zip\">\r" +
    "\n" +
    "                                </ap-google-maps>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"modal-footer\">\r" +
    "\n" +
    "                                <div class=\"row\">\r" +
    "\n" +
    "                                    <div class=\"col-xs-8 text-align-left\">\r" +
    "\n" +
    "                                        <div>\r" +
    "\n" +
    "                                            {{pendingAppointment.Provider.Name}}\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div>\r" +
    "\n" +
    "                                            {{pendingAppointment.VisitLocation.Name}}\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div>\r" +
    "\n" +
    "                                            {{pendingAppointment.VisitLocation.Address1}} | {{pendingAppointment.VisitLocation.City}}, {{pendingAppointment.VisitLocation.State}}  {{pendingAppointment.VisitLocation.Zip}}\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div>\r" +
    "\n" +
    "                                            {{pendingAppointment.VisitLocation.PhoneNumber}}\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"col-xs-4\">\r" +
    "\n" +
    "                                        <button type=\"button\" class=\"btn btn-default ap-btn-dismiss-modal\" data-dismiss=\"modal\">Close</button>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"panel-subheading\">\r" +
    "\n" +
    "                {{::'Upcoming Appointments' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div id=\"no-upcoming-appointments-div\"\r" +
    "\n" +
    "                 class=\"text-center ap-margin-bottom-30\"\r" +
    "\n" +
    "                 ng-if=\"!upcomingAppointments.length\">\r" +
    "\n" +
    "                {{::'No upcoming appointments scheduled.' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div ng-if=\"upcomingAppointments.length\" class=\"ap-margin-bottom-30\">\r" +
    "\n" +
    "                <div class=\"row panel-row\"\r" +
    "\n" +
    "                     id=\"upcoming-appointment-{{appt.AppointmentId}}\"\r" +
    "\n" +
    "                     ng-repeat=\"appt in upcomingAppointments\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-xs-flush col-sm-6 col-md-5\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-xs-flush col-sm-6 col-md-5\">\r" +
    "\n" +
    "                            <ap-date-formatter date=\"{{appt.StartDateTime}}\" format=\"date-time\"></ap-date-formatter>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <!--<div class=\"col-xs-6 col-xs-flush col-md-4\">-->\r" +
    "\n" +
    "                            <!--{{::'Add to Calendar' | translate}}-->\r" +
    "\n" +
    "                        <!--</div>-->\r" +
    "\n" +
    "                        <div class=\"col-xs-6 col-xs-flush col-md-3\">\r" +
    "\n" +
    "                            <a ng-click=\"loadMap(appt)\" class=\"clickable\" data-toggle=\"modal\" data-target=\"#VisitMap-{{appt.AppointmentId}}\">{{::'Display Map' | translate}}</a>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"col-xs-9 col-xs-flush col-sm-6 col-md-5\">\r" +
    "\n" +
    "                        <div>\r" +
    "\n" +
    "                            {{appt.AppointmentType.Name}}\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <span ng-if=\"appt.IsAppointmentToday || appt.AppointmentStatus.IsCanceledStatus\">({{appt.AppointmentStatus.Description}})</span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"clickable\">\r" +
    "\n" +
    "                        <div ng-click = \"toggleFullAppointmentDescription(appt)\">\r" +
    "\n" +
    "                            <div ng-if=\"!appt.fullAppointmentDescription\">\r" +
    "\n" +
    "                                <div class=\"overflow-ellipsis\">\r" +
    "\n" +
    "                                    {{ appt.AppointmentType.Description | limitTo: limitTo}}\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div ng-if=\"appt.fullAppointmentDescription\">\r" +
    "\n" +
    "                                <div class=\"label_wrap\">\r" +
    "\n" +
    "                                    {{ appt.AppointmentType.Description }}\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div>\r" +
    "\n" +
    "                            {{appt.Provider.Name}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div>\r" +
    "\n" +
    "                            {{appt.VisitLocation.Name}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div>\r" +
    "\n" +
    "                            {{appt.VisitLocation.Address1}} | {{appt.VisitLocation.City}}, {{appt.VisitLocation.State}}  {{appt.VisitLocation.Zip}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div>\r" +
    "\n" +
    "                            {{::'p.' | translate }} {{appt.VisitLocation.PhoneNumber}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-xs-flush col-sm-3 col-md-2\">\r" +
    "\n" +
    "                        <button class=\"btn btn-default1 pull-right\" ng-show=\"appt.CanCheckIn && canCheckInFeature && !loading\" ng-click=\"appointmentCheckIn(appt)\">\r" +
    "\n" +
    "                            {{::'Check In Now' | translate}}\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"modal fade\" id=\"VisitMap-{{appt.AppointmentId}}\" tabindex=\"-1\" role=\"dialog\">\r" +
    "\n" +
    "                        <div class=\"modal-dialog\">\r" +
    "\n" +
    "                            <div class=\"modal-content\">\r" +
    "\n" +
    "                                <div class=\"modal-header\">\r" +
    "\n" +
    "                                    <button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span>&times;</span></button>\r" +
    "\n" +
    "                                    <h4 class=\"modal-title\" id=\"myModalLabel\">{{::'Patient Visit Map' | translate}}</h4>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"modal-body\">\r" +
    "\n" +
    "                                    <ap-google-maps ng-if=\"appt.mapLoaded\"\r" +
    "\n" +
    "                                        address=\"appt.VisitLocation.Address1\"\r" +
    "\n" +
    "                                        city=\"appt.VisitLocation.City\"\r" +
    "\n" +
    "                                        state=\"appt.VisitLocation.State\"\r" +
    "\n" +
    "                                        zip=\"appt.VisitLocation.Zip\">\r" +
    "\n" +
    "                                    </ap-google-maps>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"modal-footer\">\r" +
    "\n" +
    "                                    <div class=\"row\">\r" +
    "\n" +
    "                                        <div class=\"col-xs-8 text-align-left\">\r" +
    "\n" +
    "                                            <div>\r" +
    "\n" +
    "                                                {{appt.Provider.Name}}\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                            <div>\r" +
    "\n" +
    "                                                {{appt.VisitLocation.Name}}\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                            <div>\r" +
    "\n" +
    "                                                {{appt.VisitLocation.Address1}} | {{appt.VisitLocation.City}}, {{appt.VisitLocation.State}}  {{appt.VisitLocation.Zip}}\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                            <div>\r" +
    "\n" +
    "                                                {{appt.VisitLocation.PhoneNumber}}\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div class=\"col-xs-4\">\r" +
    "\n" +
    "                                            <button type=\"button\" class=\"btn btn-default ap-btn-dismiss-modal\" data-dismiss=\"modal\">Close</button>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"panel-subheading\">\r" +
    "\n" +
    "                {{::'Previous Appointments' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div id=\"no-previous-appointments-div\"\r" +
    "\n" +
    "                 class=\"text-center\"\r" +
    "\n" +
    "                 ng-if=\"!previousAppointments.length\">\r" +
    "\n" +
    "                {{::'No previous appointments found.' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"row panel-row\"\r" +
    "\n" +
    "                 id=\"previous-appointment-{{appt.AppointmentId}}\"\r" +
    "\n" +
    "                 ng-repeat=\"appt in previousAppointments\">\r" +
    "\n" +
    "                <div class=\"col-xs-12 col-xs-flush col-sm-3\">\r" +
    "\n" +
    "                    <div>\r" +
    "\n" +
    "                        <ap-date-formatter date=\"{{appt.StartDateTime}}\" format=\"date-time\"></ap-date-formatter>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div ng-if=\"appt.AppointmentStatus.IsCanceledStatus\">\r" +
    "\n" +
    "                         ({{appt.AppointmentStatus.Description}})\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-12 col-xs-flush col-sm-4\">\r" +
    "\n" +
    "                    <div>\r" +
    "\n" +
    "                        {{appt.AppointmentType.Description}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div>\r" +
    "\n" +
    "                        {{appt.Provider.Name}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-12 col-xs-flush col-sm-5\">\r" +
    "\n" +
    "                    <div>\r" +
    "\n" +
    "                        {{appt.VisitLocation.Name}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div>\r" +
    "\n" +
    "                        {{appt.VisitLocation.Address1}}&nbsp;|&nbsp;{{appt.VisitLocation.City}},&nbsp;{{appt.VisitLocation.State}}&nbsp;&nbsp;{{appt.VisitLocation.Zip}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                {{::'An error has occurred and the patient appointments could not be loaded.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                {{::'You do not have access to this patient\\'s appointments.'| translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/myappointments/views/scheduleAppointment.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-primary\">\r" +
    "\n" +
    "        <div class=\"panel-heading-appointments panel-flush\">\r" +
    "\n" +
    "            {{::'Schedule An Appointment' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"text-center ap-margin-bottom-15\">\r" +
    "\n" +
    "            {{:: 'Fill out the appointment request below to request a new appointment and we will send it over to the practice for review and confirmation.' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "            <div class=\"panel-body\">\r" +
    "\n" +
    "                <form name=\"appointmentRequestForm\" novalidate>\r" +
    "\n" +
    "                    <div class=\"panel-subheading\">\r" +
    "\n" +
    "                        {{::'Details' | translate}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"row panel-row-no-border-bottom\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                            <div class=\"form-group\"\r" +
    "\n" +
    "                                 ng-class=\"{ 'has-error' : (appointmentRequestForm.Calendar.$invalid\r" +
    "\n" +
    "                                                                && (appointmentRequestForm.Calendar.$dirty\r" +
    "\n" +
    "                                                                        || appointmentRequestForm.isSubmitted))}\">\r" +
    "\n" +
    "                                <label class=\"control-label\">{{::'Select a Calendar' | translate}}</label>\r" +
    "\n" +
    "                                    <select\r" +
    "\n" +
    "                                        class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "                                        name=\"Calendar\"\r" +
    "\n" +
    "                                        ng-change=\"selectedCalendarChanged()\"\r" +
    "\n" +
    "                                        ng-model=\"appointment.Calendar.Id\"\r" +
    "\n" +
    "                                        ng-disabled=\"sending\"\r" +
    "\n" +
    "                                        ap-required=\"true\"\r" +
    "\n" +
    "                                        ng-options=\"calendar.Id as calendar.Description for calendar in patientCalendars\">\r" +
    "\n" +
    "                                    </select>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"row panel-row-no-border-bottom\" ng-show=\"appointmentLocationDefined\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-sm-4 col-md-5 col-xs-flush\">\r" +
    "\n" +
    "                            <ap-google-maps ng-if=\"appointmentLocationDefined\"\r" +
    "\n" +
    "                                    address=\"appointmentLocation.Address1\"\r" +
    "\n" +
    "                                    city=\"appointmentLocation.City\"\r" +
    "\n" +
    "                                    state=\"appointmentLocation.State\"\r" +
    "\n" +
    "                                    zip=\"appointmentLocation.Zip\">\r" +
    "\n" +
    "                            </ap-google-maps>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-sm-4 col-md-5\">\r" +
    "\n" +
    "                            <label class=\"control-label\">{{::'Location Details' | translate}}</label>\r" +
    "\n" +
    "                            <div>\r" +
    "\n" +
    "                                {{appointmentLocation.Name}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div>\r" +
    "\n" +
    "                                {{appointmentLocation.Address1}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div>\r" +
    "\n" +
    "                                {{appointmentLocation.Address2}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div>\r" +
    "\n" +
    "                                {{appointmentLocation.City}},&nbsp;{{appointmentLocation.State}}&nbsp;&nbsp;{{appointmentLocation.Zip}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div ng-if=\"appointmentLocation.PhoneNumber\">\r" +
    "\n" +
    "                            <div class=\"col-xs-12 col-sm-4 col-md-2 col-xs-flush\">\r" +
    "\n" +
    "                                <div class=\"pull-right\">\r" +
    "\n" +
    "                                {{::'p.' | translate }} {{appointmentLocation.PhoneNumber}}\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"row panel-row-no-border-bottom\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                            <div class=\"form-group\"\r" +
    "\n" +
    "                                 ng-class=\"{ 'has-error' : (appointmentRequestForm.AppointmentType.$invalid\r" +
    "\n" +
    "                                                                && (appointmentRequestForm.AppointmentType.$dirty\r" +
    "\n" +
    "                                                                        || appointmentRequestForm.isSubmitted))}\">\r" +
    "\n" +
    "                                <label class=\"control-label\">{{::'Select an appointment type' | translate}}</label>\r" +
    "\n" +
    "                                    <select\r" +
    "\n" +
    "                                        class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "                                        name=\"AppointmentType\"\r" +
    "\n" +
    "                                        ng-model=\"appointment.AppointmentType.Id\"\r" +
    "\n" +
    "                                        ng-change=\"selectedAppointmentTypeChanged()\"\r" +
    "\n" +
    "                                        ng-disabled=\"sending\"\r" +
    "\n" +
    "                                        ap-required=\"true\"\r" +
    "\n" +
    "                                        ng-options=\"apptType.Id as apptType.Name for apptType in patientAppointmentTypes\">\r" +
    "\n" +
    "                                    </select>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                <div ng-if=\"selectedAppointmentTypeDescription\">\r" +
    "\n" +
    "                                    <label class=\"control-label\">{{::'Appointment Description' | translate}}</label>\r" +
    "\n" +
    "                                    <div class=\"secondary-text-semi-bold-light\">\r" +
    "\n" +
    "                                        <div class=\"label_wrap\">\r" +
    "\n" +
    "                                                {{selectedAppointmentTypeDescription}}\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"row panel-row-no-border-bottom\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                            <div class=\"form-group\">\r" +
    "\n" +
    "                                <label class=\"control-label\">{{::'Reason for the appointment' | translate}}</label>\r" +
    "\n" +
    "                                    <textarea\r" +
    "\n" +
    "                                        class=\"form-control\"\r" +
    "\n" +
    "                                        name=\"AppointmentReason\"\r" +
    "\n" +
    "                                        ng-model=\"appointment.Reason\"\r" +
    "\n" +
    "                                        placeholder=\"Appointment reason here\"\r" +
    "\n" +
    "                                        ng-disabled=\"sending\"\r" +
    "\n" +
    "                                        rows=\"3\">\r" +
    "\n" +
    "                                    </textarea>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"row panel-row-no-border-bottom\">\r" +
    "\n" +
    "                        <div class=\"panel-subheading\">\r" +
    "\n" +
    "                            {{::'Timing' | translate}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"row panel-row-no-border-bottom\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-sm-6 col-xs-flush\">\r" +
    "\n" +
    "                            <div class=\"form-group\"\r" +
    "\n" +
    "                                 ng-class=\"{ 'has-error' : (appointmentRequestForm.RequestDate.$invalid && (appointmentRequestForm.RequestDate.$dirty || appointmentRequestForm.isSubmitted))}\">\r" +
    "\n" +
    "                                <label class=\"control-label\">\r" +
    "\n" +
    "                                    {{:: 'Select a date and the available times will be listed.' | translate}}\r" +
    "\n" +
    "                                    &nbsp;<span class=\"fa fa-asterisk\"></span>\r" +
    "\n" +
    "                                </label>\r" +
    "\n" +
    "                                <div class=\"ap-datepicker\">\r" +
    "\n" +
    "                                    <uib-datepicker\r" +
    "\n" +
    "                                        name=\"RequestDate\"\r" +
    "\n" +
    "                                        ng-change=\"datePickerChanged()\"\r" +
    "\n" +
    "                                        ng-model=\"datePicker.selectedDate\"\r" +
    "\n" +
    "                                        ng-disabled=\"sending\"\r" +
    "\n" +
    "                                        datepicker-options=\"datepickerOptions\"\r" +
    "\n" +
    "                                        class=\"well well-sm\">\r" +
    "\n" +
    "                                    </uib-datepicker>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-sm-6 col-xs-flush\">\r" +
    "\n" +
    "                            <div class=\"form-group\"\r" +
    "\n" +
    "                                 ng-class=\"{ 'has-error' : (selectedTimeSlotInvalid && appointmentRequestForm.isSubmitted)}\">\r" +
    "\n" +
    "                                <label class=\"control-label\">\r" +
    "\n" +
    "                                    {{::'Available Times' | translate}}\r" +
    "\n" +
    "                                    &nbsp;<span class=\"fa fa-asterisk\"></span>\r" +
    "\n" +
    "                                </label>\r" +
    "\n" +
    "                                <div ng-show=\"loadingAppointmentSlots\">\r" +
    "\n" +
    "                                    <ap-spinner size=\"2\"></ap-spinner>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div ng-if=\"appointment.Calendar.TimeZone\">\r" +
    "\n" +
    "                                    <label class=\"form-group timezone\">{{appointment.Calendar.TimeZone}}</label>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div id=\"no-open-appointment-slots-div\"\r" +
    "\n" +
    "                                     ng-if=\"!openAppointmentSlots.length && !loadingAppointmentSlots\">\r" +
    "\n" +
    "                                    <div class=\"control-label\">{{::'None Available.' | translate}}</div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                <div class=\"panel-open-appointment-slots\" ng-disabled=\"sending\" ng-if=\"!loadingAppointmentSlots\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                    <div class=\"ap-radio-wrapper ap-timeslot-item\"\r" +
    "\n" +
    "                                         scroll-to=\"apptSlot.Selected\"\r" +
    "\n" +
    "                                         ng-repeat=\"apptSlot in openAppointmentSlots track by $index\">\r" +
    "\n" +
    "                                        <input type=\"radio\"\r" +
    "\n" +
    "                                               name=\"SelectedTimeSlot\"\r" +
    "\n" +
    "                                               id=\"selected-time-{{$index}}\"\r" +
    "\n" +
    "                                               ng-value=\"apptSlot.StartDate\"\r" +
    "\n" +
    "                                               ng-model=\"appointment.RequestDateTime\"\r" +
    "\n" +
    "                                               ng-click=\"SelectedTimeSlotClick()\"\r" +
    "\n" +
    "                                               ng-disabled=\"sending\"/>\r" +
    "\n" +
    "                                        <label for=\"selected-time-{{$index}}\">\r" +
    "\n" +
    "                                            <ap-date-formatter date=\"{{apptSlot.StartDate}}\" format=\"time\"></ap-date-formatter>\r" +
    "\n" +
    "                                        </label>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div>\r" +
    "\n" +
    "                                    {{::'Selected Appointment Time: ' | translate}}\r" +
    "\n" +
    "                                    <div ng-if=\"appointment.RequestDateTime\">\r" +
    "\n" +
    "                                        <ap-date-formatter date=\"{{appointment.RequestDateTime}}\" format=\"date-time\"></ap-date-formatter>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div ng-if=\"appointment.Calendar.TimeZone\">\r" +
    "\n" +
    "                                        <div class=\"form-group timezone-inline\">{{appointment.Calendar.TimeZone}}</div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div ng-if=\"!appointment.RequestDateTime && openAppointmentSlots.length\">\r" +
    "\n" +
    "                                        {{::'Please select an appointment time.'}}\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"row panel-row-no-border-bottom\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12\">\r" +
    "\n" +
    "                            <button\r" +
    "\n" +
    "                                id=\"cancel-btn\"\r" +
    "\n" +
    "                                class=\"btn btn-default2 btn-lg pull-left\"\r" +
    "\n" +
    "                                ng-disabled=\"sending\"\r" +
    "\n" +
    "                                data-transition-to=\"{appRoute: 'myAppointments'}\">\r" +
    "\n" +
    "                                    {{::'Cancel' | translate}}\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                            <button\r" +
    "\n" +
    "                                id=\"request-appointment-btn\"\r" +
    "\n" +
    "                                class=\"btn btn-primary btn-lg pull-right\"\r" +
    "\n" +
    "                                ng-disabled=\"sending\"\r" +
    "\n" +
    "                                ng-click=\"requestAppointment(appointmentRequestForm)\">\r" +
    "\n" +
    "                                    <span ng-show=\"sending\"><ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "                                    {{::'Request Appointment' | translate}}\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </form>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                {{::'An error has occurred and the patient appointments could not be loaded.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                {{::'You do not have access to this patient\\'s appointments.'| translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );

}]);
